import {
  currencyFormatter,
  numberFormatter,
} from "@/common/services/formatter";
import {
  AmountDiscountValueType,
  CropCategory,
  Currency,
} from "@/generated/digitalnisklady.cz/graphql";

type Discount = {
  currency: Currency | null;
  fromAmount: number;
  id: string;
  toAmount: number;
  type: string;
  value: number;
  valueType: AmountDiscountValueType;
};

const getPriceDecimalPlaces = (
  category: CropCategory,
  currency: string,
): number => {
  if (category === CropCategory.Fuel) {
    return 2;
  }
  return currency === "CZK" ? 0 : 2;
};

const calculateFinalPrice = (discount: Discount, basePrice: number): number => {
  switch (discount.valueType) {
    case AmountDiscountValueType.Percent:
      // Apply percentage discount: basePrice * (100 - discount) / 100
      return (basePrice * (100 - discount.value)) / 100;
    case AmountDiscountValueType.DiscountInPrice:
      // Subtract discount value from base price
      return basePrice - discount.value;
    case AmountDiscountValueType.FinalPrice:
      // Use the value as-is
      return discount.value;
    default:
      return basePrice;
  }
};

const formatDiscount = (
  discount: Discount,
  basePrice: number,
  currency: string,
  unit: string,
  category: CropCategory,
): string => {
  const formatter = numberFormatter();
  const range = `${formatter.format(discount.fromAmount)}-${formatter.format(discount.toAmount)} ${unit}`;
  const maximumFractionDigits = getPriceDecimalPlaces(category, currency);
  const finalPrice = calculateFinalPrice(discount, basePrice);
  const priceText = currencyFormatter(currency, {
    maximumFractionDigits,
  }).format(finalPrice);
  return `${range}: ${priceText}`;
};

export { calculateFinalPrice, formatDiscount, getPriceDecimalPlaces };
export type { Discount };
